import {Component} from "@angular/core";

@Component({
    selector: "wbo-edit-grid-footer",
    styleUrls: ["./edit-grid-footer.component.scss"],
    templateUrl: "./edit-grid-footer.component.html"
})
export class EditGridFooterComponent {
    constructor() {
    }
}
